import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router';
import {
    Row, Card
} from 'reactstrap';
import { H4, LI, P, Image, UL, Btn, H6 } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import { useSelector, useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteCategory } from 'Services/Features/Category/Utils/categoryUtils';
import { setFormData } from 'Services/Features/Category/categorySlice';
import Moment from 'react-moment';

const CategoryContent = ({ setRefetch }) => {
    const categories = useSelector((state) => state.category.categories);
    
    // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const layoutColumns = 3;
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photos dan banner ke state terpisah
        dispatch(setFormData({ bannerLink: item.banner }));

        // Buat objek baru tanpa banner
        const { banner, ...updatedItem } = item;
        dispatch(setFormData({
            ...updatedItem,
        }));

        history(`${process.env.PUBLIC_URL}/treatment-category/edit/${item.id}`);
    };




    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {categories && categories.map((item) => {
                        return (
                            <div id="gridId" className={`${layoutColumns === 3 ? 'col-xl-3 col-lg-6 col-sm-6 xl-4' : 'col-xl-' + layoutColumns}`} key={item.id}>
                                <Card >
                                    <div className="product-box">
                                        <div className="product-img" style={{ height: '200px', overflow: 'hidden' }}>
                                            <Image attrImage={{ className: 'img-fluid w-100', src: item.banner ? item.banner : errorImg, alt: `${item.name}`, style: { height: '100%', objectFit: 'cover' } }} />
                                            <div className="product-hover">
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Delete" onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteCategory)}><Btn attrBtn={{ color: 'transprant', type: 'button', datatoggle: 'modal', datatarget: '#exampleModalCenter' }}><i className="icon-trash"></i></Btn> </LI>
                                                    <LI title="Edit" onClick= {() => handleEdit(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-pencil-alt"></i></Btn></LI>
                                                </UL>
                                            </div>
                                        </div>
                                        <div className="product-details">
                                            <H4>
                                                <span title={item.name} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                    {item.name && item.name.length > 23 ? `${item.name.substring(0, 23)}...` : item.name}
                                                </span>
                                            </H4>
                                            <span title={item.about} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                {item.about && item.about.length > 36 ? `${item.about.substring(0, 36)}...` : item.about}
                                            </span>
                                            <P><i className="icon-alarm-clock me-2"></i> 
                                                <Moment format="DD MMM YYYY, hh:mm:ss">
                                                    {item.created_at}
                                                </Moment>
                                            </P>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </Row>
            </div>
        </Fragment>
    );
};
export default CategoryContent;